import 'css-chunksrc/client/scenes/resourceGroupEdition/groupEditionForm/resourcesList/resourceSelect/styles.scss';export default {
  "container": "_container_byh9h_1",
  "icon": "_icon_byh9h_5",
  "list": "_list_byh9h_11",
  "scrollContainer": "_scrollContainer_byh9h_20"
};